import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Navbar1 from "../src/components/navbar/navbar";
import Lims from "../src/components/lims/lims";
import Short from "./components/short/short";
import Contact from "./components/contactus/contact";
import Events from "./components/nlsasociety/events";
import Tours from "./components/nlsasociety/tours";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navbar1 />,
  },
  {
    path: "/lims",
    element: <Lims />,
  },
  {
    path: "/shortcourses",
    element: <Short />,
  },
  {
    path: "/contactus",
    element: <Contact />,
  },
  {
    path: "/events",
    element: <Events />,
  },
  {
    path: "/tours",
    element: <Tours />,
  },
]);
function Routes1() {
  return <RouterProvider router={router} />;
}

export default Routes1;
